import { AxiosInstance } from 'axios';
import { DutiesRepository } from '@/model/repository/shift/DutiesRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): DutiesRepository => ({
    index() {
      return Repository.get(`${resource}`, { data: { errorHandle: false } });
    },
    show(id) {
      return Repository.get(`${resource}/${id}`);
    },
    create(payload) {
      return Repository.post(`${resource}`, payload);
    },
    update(id, payload) {
      return Repository.put(`${resource}/${id}`, payload);
    },
  });
